export const isOverflown = ({ clientWidth, clientHeight, scrollWidth, scrollHeight }: HTMLElement) => {
    return scrollHeight > clientHeight || scrollWidth > clientWidth;
}

export const onlyNumberHandler = (target: HTMLInputElement, callBack: (target: HTMLInputElement, value: string) => void) => {

    const { value } = target;
    const originalCaret = target.selectionEnd;
    const originalGap = value.length - (originalCaret || 0);
    const replace = value
        .replace(/-/g, "") //"-"제거
        .replace(/[^0-9]/g, ""); //숫자를제거한 나머지 모두 제거

    target.value = replace;
    target.focus();

    //캐럿을 따로 설정해주지 않으면, target.value = newValue로 인해서 캐럿이 항상 마지막으로 이동한다.
    const newPosition = replace.length - originalGap;
    target.setSelectionRange(newPosition, newPosition);
    callBack(target, value)
}

export function formatKoreanRegistrationNumberHandler(e: Event, callBack: (target: HTMLInputElement, value: string) => void) {
    const target = e.target as HTMLInputElement
    const value = target.value
    const originalCaret = target.selectionEnd;
    const originalGap = value.length - (originalCaret || 0);
    const replace = value
        .replace(/[^0-9]/g, "");

    target.value = addKoreanRegisterSpacer(replace);
    target.focus();
    //캐럿을 따로 설정해주지 않으면, target.value = newValue로 인해서 캐럿이 항상 마지막으로 이동한다.
    const newPosition = addKoreanRegisterSpacer(replace).length - originalGap;
    target.setSelectionRange(newPosition, newPosition);
    callBack(target, value.replace(/[^0-9]/g, ""))
}

export function addKoreanRegisterSpacer(value: string, spacer = "-") {
    return value
        .replace(/[^0-9]/g, "")
        .replace(
            /(\d{3,3})(\d{2})(\d{1,5})$/,
            `$1${spacer}$2${spacer}$3`
        )
}

export function detectMob() {
    const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
    ];

    return toMatch.some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem);
    });
}